<template>
  <div class="h5-carts-list">
    <template v-if="!isAllEmpty">
      <div class="h5-carts-list__header">
        <div
          class="h5-carts-list__status"
          :class="{
            'h5-carts-list__status--active': frontCartStats === item.value
          }"
          v-for="item of status"
          :key="item.value"
          @click="frontCartStats = item.value"
        >
          {{ item.label }}
        </div>
      </div>
      <CartsSkeleton v-if="loading" />
      <div
        class="h5-carts-list__content"
        v-else
      >
        <CartsItem
          v-if="cartList.length"
          v-for="item of cartList"
          :item="item"
          :key="item.offerId"
        />
        <Result
          v-else
          :image="EmptyCartImage"
          title="It is empty here :-("
        />
      </div>
    </template>
    <Result
      v-else
      class="h5-carts-list__empty"
      :image="EmptyImage"
      title="Your shopping carts is empty."
      sub-title="Add your purchase items in it."
      button="Shop Now"
      @button-click="$router.push({ name: 'home' })"
    />
  </div>
</template>

<script setup>
import { Result } from '@/components/Result'
import CartsItem from './CartsItem.vue'
import { useCart } from '@/views/Carts/hooks/useCart'
import EmptyCartImage from '@/assets/illus/illus-my-cart.svg'
import EmptyImage from '@/assets/result/empty.svg'
import CartsSkeleton from './CartsSkeleton.vue'

const { loading, isAllEmpty, cartList, frontCartStats } = useCart()

const status = ref([
  { label: 'All', value: null },
  { label: 'Available', value: '2' },
  { label: 'Processing', value: '0' },
  { label: 'Unavailable', value: '1' }
])
</script>

<style lang="less" scoped>
.h5-carts-list {
  &__header {
    z-index: 2;
    position: sticky;
    top: 0;
    border-radius: 8px;
    background-color: #FFFFFF;
    padding: 16px 12px 8px;
    display: flex;
    gap: 12px;
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__status {
    flex-shrink: 0;
    min-width: 60px;
    padding: 12px 16px;
    background-color: #F8F8F8;
    border-radius: 20px;
    text-align: center;
    font-family: mon-600;
    font-size: 12px;
    line-height: 16px;

    &--active {
      color: #FFFFFF;
      background-color: #232323;
    }
  }

  &__empty {
    padding-top: 48px;
  }
}
</style>
